export default __webpack_public_path__ + "static/media/logo-enlong.a9b97a8d.png";